import React, { useState, useEffect } from "react";
import { Card, Button } from "../../../../components/common/";
import { ReactComponent as CompaniesFollow } from "../../../../assets/icons/CompanyYouFollow.svg";
import { ReactComponent as Image } from "../../../../assets/icons/Image.svg";
import { ReactComponent as PlusPrimary } from "../../../../assets/icons/PlusPrimary.svg";
import { useGetUserQuery } from "../../../../store/auth/usersApiSlice";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getCountryByCode } from "../../../../utils/Helper";

export const CompaniesYouFollow = () => {
  const [followData, setFollowData] = useState([]);
  const [companyData, setCompanyData] = useState(false);
  const { userInfo, token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (userInfo) {
      if (userInfo?.companyFollow?.length > 0) {
        setFollowData(userInfo?.companyFollow);
        setCompanyData(true);
      }
    }
  }, [userInfo]);

  return (
    <Card classes="w-full col-start-1 col-end-9 bg-white rounded-lg p-3 my-5 pkp">
      <div className="text-secondarytwo font-semibold flex justify-between p-3 text-f16 tracking-wider ">
        <p>
          Followed Companies
          <span className="text-purple text-f12 font-regular bg-role px-2 py-1 rounded-full ml-2">
            {followData.length > 100
              ? `${followData.length}+`
              : followData.length}
          </span>
        </p>
        {followData.length > 100 ? (
          <Link to="#" className="text-link text-f16">
            View All
          </Link>
        ) : null}
      </div>
      {followData.length < 1 ? (
        <div className="flex flex-col items-center gap-5 justify-center sm:w-1/3 mx-auto p-5 ">
          <CompaniesFollow />
          <span className="text-secondary text-f14">
            Follow companies and stay updated about any changes
          </span>
          <Link
            to="/search"
            target="_blank"
            className="border-link text-link font-semibold border py-2 px-5 rounded text-f14"
          >
            Start Following
          </Link>
        </div>
      ) : (
        <div>
          <div className="py-5 border-b max-h-80 overflow-y-auto">
            {followData.map((item) => (
              <>
                <Link to={"/search/" + item.companyID.companyID} target="_blank">
                  <div className="flex gap-3 p-2 rounded hover:bg-header my-2">
                    <Image />
                    <div className="flex flex-col text-left text-f14">
                      <span className="font-normal text-secondarytwo">
                        {item.companyID.registered_company_name}
                      </span>
                      <span className="location text-secondary font-light pt-1">
                        {getCountryByCode(item.companyID.country_code)}
                      </span>
                    </div>
                  </div>
                </Link>
              </>
            ))}
          </div>
          <Link
            to="/search"
            className="text-link font-semibold text-left pt-5 p-3 flex gap-5 items-center"
          >
            <PlusPrimary />
            Start Following new Companies
          </Link>
        </div>
      )}
    </Card>
  );
};
